import { useEffect, useState } from "react";
import api, { errText } from "@/lib/api";
import { toast } from "sonner";
import { UserPlus, Link2 } from "lucide-react";

const ROLES = [["leadgen", "Lead-Gen"], ["bde", "BDE"], ["admin", "Admin"]];

export default function Users() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "leadgen" });

  const load = () => api.get("/auth/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const bdes = users.filter((u) => u.role === "bde");

  const create = async () => {
    if (!form.name || !form.email || !form.password) { toast.error("All fields required"); return; }
    try { await api.post("/auth/users", form); toast.success("User created"); setForm({ name: "", email: "", password: "", role: "leadgen" }); load(); }
    catch (e) { toast.error(errText(e)); }
  };

  const linkBde = async (uid, bdeId) => {
    try { await api.patch(`/auth/users/${uid}`, { assigned_bde: bdeId || null }); toast.success("BDE assignment updated"); load(); }
    catch (e) { toast.error(errText(e)); }
  };

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="font-head text-2xl font-extrabold tracking-tight mb-1">Team</h1>
      <p className="text-xs text-zinc-500 font-mono mb-5">Manage roles and link each Lead-Gen rep to the BDE who receives their converted leads</p>

      <div className="bg-white border-2 border-black p-4 mb-6 rounded-xl">
        <div className="text-xs font-bold uppercase tracking-wider mb-3">Add teammate</div>
        <div className="grid md:grid-cols-2 gap-3">
          <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-zinc-400 px-2 py-2 text-sm rounded-lg" data-testid="user-name" />
          <input placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="border border-zinc-400 px-2 py-2 text-sm rounded-lg" data-testid="user-email" />
          <input placeholder="Password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="border border-zinc-400 px-2 py-2 text-sm rounded-lg" data-testid="user-password" />
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="border border-zinc-400 px-2 py-2 text-sm rounded-lg" data-testid="user-role">
            {ROLES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
        <button onClick={create} className="mt-3 flex items-center gap-2 bg-klein hover:bg-klein-hover text-white px-4 py-2 text-sm font-medium transition-colors rounded-lg" data-testid="create-user-btn">
          <UserPlus className="h-4 w-4" /> Create user
        </button>
      </div>

      <div className="bg-white border border-zinc-300 rounded-xl overflow-hidden">
        {users.map((u) => (
          <div key={u.id} className="flex items-center justify-between px-4 py-3 border-b border-zinc-200 last:border-0" data-testid={`user-row-${u.id}`}>
            <div className="min-w-0">
              <div className="font-medium text-sm">{u.name}</div>
              <div className="text-xs text-zinc-500 font-mono">{u.email}</div>
            </div>
            <div className="flex items-center gap-3">
              {u.role === "leadgen" && (
                <div className="flex items-center gap-1.5" title="Converted leads go to this BDE">
                  <Link2 className="h-3.5 w-3.5 text-zinc-400" />
                  <select data-testid={`assign-bde-${u.id}`} value={u.assigned_bde || ""} onChange={(e) => linkBde(u.id, e.target.value)}
                    className="border border-zinc-300 rounded-lg text-xs px-2 py-1.5 focus:border-klein focus:outline-none">
                    <option value="">— link a BDE —</option>
                    {bdes.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
                  </select>
                </div>
              )}
              <span className="text-[10px] uppercase font-mono bg-zinc-900 text-white px-2 py-1 rounded">{u.role}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
